module.exports = __webpack_public_path__ + "img/pi.457b1c15.svg";